import {MAP_MIN_ZOOM,WEB_MAP_MAX_ZOOM} from './map-zoom.js';
export function zoomAt(camera,delta,x,y,width,height){
  const zoom=Math.max(MAP_MIN_ZOOM,Math.min(WEB_MAP_MAX_ZOOM,camera.zoom+delta));
  const before=256*2**camera.zoom,after=256*2**zoom;
  return {zoom,x:camera.x+(x-width/2)*(1/before-1/after),y:Math.max(0,Math.min(1,camera.y+(y-height/2)*(1/before-1/after)))};
}
export function panCamera(camera,dx,dy){
  const scale=256*2**camera.zoom;
  return {...camera,x:camera.x-dx/scale,y:Math.max(0,Math.min(1,camera.y-dy/scale))};
}
